<template lang="html">
    <div>
        <UiInput
            label="Parolă nouă"
            type="password"
            icon="fa fa-lock"
            :value="firstStep.password"
            :error="errors.password"
            @input="updatePassword"
            @blur="validatePassword"
            @focus="errors.password = ''"
        />
        <p class="error">{{apiError}}</p>
    </div>
</template>

<script>

import UiInput from "@/components/ui/Input"
import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput
    },
    data() {
        return {
            password: '',
            passwordConfirmation: '',
            errors: {
                password: '',
                passwordConfirmation: ''
            },
            apiError: null
        };
    },
    computed: {
        ...mapGetters({
            firstStep: 'settings/firstStep'
        })
    },
    methods: {
        validatePassword() {
            this.apiError = null;
            if(this.firstStep.password.length > 0 && this.firstStep.password.length < 6 || this.firstStep.password.length > 30) {
                this.errors.password = 'Parola trebuie sa contina minim 6 si maxim 30 de caractere';
            } else {
                this.errors.password = '';
                this.errors.passwordConfirmation = '';
            }
        },
        activeButton() {
            this.$emit('activeButton', this.firstStep.password.length >= 6);
        },
        updatePassword(event) {
            this.$store.state.settings.steps[0].payload['password'] = event;
            this.$store.state.settings.steps[0].payload['password_confirmation'] = event;
            this.activeButton();
        },
        updatePasswordConfirmation(event) {
            this.$store.state.settings.steps[0].payload['password_confirmation'] = event;
            this.activeButton();
        }
    },
    watch: {
        "$store._modules.root.state.notification.notification"(notification) {
            if(notification.icon == 'error' && this.$store._modules.root.state.settings.currentStep == 0) {
                this.errors = [];
                this.apiError = notification.title;
            }
        },
        "$store._modules.root.state.settings.steps.0.payload.password"(password) {
            this.activeButton();
        }
    }
}
</script>
